import React from 'react';
import { IconType } from '@/types';

export default function CheckCircleIcon({ color = '#7DB942', width = 24, height = 24 }: IconType) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 39 39'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_354_5344)'>
        <ellipse cx='18.75' cy='18.75' rx='15.75' ry='14.25' fill='white' />
        <path
          d='M19.5001 2.16666C16.0719 2.16666 12.7207 3.18324 9.87021 5.08785C7.01975 6.99246 4.7981 9.69956 3.48618 12.8668C2.17426 16.0341 1.831 19.5192 2.49981 22.8816C3.16862 26.2439 4.81946 29.3324 7.24357 31.7565C9.66768 34.1806 12.7562 35.8315 16.1185 36.5003C19.4809 37.1691 22.966 36.8258 26.1333 35.5139C29.3005 34.202 32.0076 31.9803 33.9122 29.1299C35.8168 26.2794 36.8334 22.9282 36.8334 19.5C36.8334 14.9029 35.0072 10.4941 31.7566 7.24347C28.506 3.99284 24.0972 2.16666 19.5001 2.16666ZM30.8209 13.6825L16.5859 27.9067L8.17926 19.5C7.89194 19.2127 7.73052 18.823 7.73052 18.4167C7.73052 18.0103 7.89194 17.6206 8.17926 17.3333C8.46657 17.046 8.85626 16.8846 9.26259 16.8846C9.66892 16.8846 10.0586 17.046 10.3459 17.3333L16.6076 23.595L28.6759 11.5375C28.8182 11.3952 28.9871 11.2824 29.173 11.2054C29.3588 11.1284 29.5581 11.0888 29.7593 11.0888C29.9605 11.0888 30.1597 11.1284 30.3456 11.2054C30.5314 11.2824 30.7003 11.3952 30.8426 11.5375C30.9849 11.6798 31.0977 11.8486 31.1747 12.0345C31.2517 12.2204 31.2913 12.4196 31.2913 12.6208C31.2913 12.822 31.2517 13.0212 31.1747 13.2071C31.0977 13.393 30.9849 13.5619 30.8426 13.7042L30.8209 13.6825Z'
          fill={color}
        />
      </g>
    </svg>
  );
}
